import circle from './assets/circle.svg'

export const solidIcons = {
  circle,
} as const

export type SolidIconName = keyof typeof solidIcons
